import {lazy, FC, Suspense} from 'react'
import {Route, Routes, Navigate} from 'react-router-dom'
import {MasterLayout} from '../../_metronic/layout/MasterLayout'
import TopBarProgress from 'react-topbar-progress-indicator'
import {DashboardWrapper} from '../pages/dashboard/DashboardWrapper'
import {getCSSVariableValue} from '../../_metronic/assets/ts/_utils'
import StudentsMarksPage from '../modules/students/StudentsMarksPage'

const AdminRoutes = () => {
  const StudentsPage = lazy(() => import('../modules/students/StudentsPage'))
  const SupervisorsPage = lazy(() => import('../modules/supervisors/SupervisorsPage'))
  const ReadersPage = lazy(() => import('../modules/readers/ReadersPage'))
  const FYPCoordinatorsPage = lazy(() => import('../modules/fyp-coordinators/FYPCoordinatorsPage'))
  const AccountPage = lazy(() => import('../modules/accounts/AccountPage'))
  const FeedbacksPage = lazy(() => import('../modules/feedbacks/FeedbacksPage'))

  return (
    <Routes>
      <Route element={<MasterLayout />}>
        <Route path='dashboard' element={<DashboardWrapper />} />
        <Route
          path='students/*'
          element={
            <SuspensedView>
              <StudentsPage />
            </SuspensedView>
          }
        />
        <Route
          path='supervisors/*'
          element={
            <SuspensedView>
              <SupervisorsPage />
            </SuspensedView>
          }
        />
        <Route
          path='readers/*'
          element={
            <SuspensedView>
              <ReadersPage />
            </SuspensedView>
          }
        />
        <Route
          path='fyp-coordinators/*'
          element={
            <SuspensedView>
              <FYPCoordinatorsPage />
            </SuspensedView>
          }
        />
        <Route
          path='marks/*'
          element={
            <SuspensedView>
              <StudentsMarksPage />
            </SuspensedView>
          }
        />
        <Route
          path='profile/*'
          element={
            <SuspensedView>
              <AccountPage />
            </SuspensedView>
          }
        />
        <Route
          path='feedbacks/*'
          element={
            <SuspensedView>
              <FeedbacksPage />
            </SuspensedView>
          }
        />
        <Route path='*' element={<Navigate to='/error/404' />} />
      </Route>
    </Routes>
  )
}

const SuspensedView: FC = ({children}) => {
  const baseColor = getCSSVariableValue('--bs-primary')
  TopBarProgress.config({
    barColors: {
      '0': baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  })
  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>
}

export {AdminRoutes}
